import Superagent from 'superagent'
import Storage from './storage.service'
import Access from '../$methods/access.methods'

const { HOST_API } = _CONSTANTS_

export default {
    getInvoices,
    getInvoicesReport,
    getInvoiceDocument,
    getClient,
    createClient,
    getInvoiceAmount,
    createInvoice,
    createInvoiceFree,
    updateClient
}

function getInvoices(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/facturama/invoices`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .end((err, res) => {
                // sin respuesta (H12 de Heroku o red caída) la tabla quedaba cargando para siempre
                if(!res || !res.body)
                    return resolve({ success: false, error: { message: 'No se pudo conectar con el servidor' } })

                resolve(res.body)
            })
    })
}

function getInvoicesReport(query) {
    return new Promise((resolve, reject) => {

        Superagent
            .get(`${HOST_API}/facturama/invoices/report`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function getInvoiceDocument(invoiceId, type) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/facturama/invoices/${invoiceId}/${type}`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getInvoiceAmount(userId) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/facturama/invoices/amount`)
            .set('access', Storage.getItem('access'))
            .query({ timezone, userId })
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function getClient(userId, facturamaId) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/facturama/clients`)
            .set('access', Storage.getItem('access'))
            .query({ userId, facturamaId })
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function createClient(data) {
    return new Promise((resolve, reject) => {
        Superagent
            .post(`${HOST_API}/facturama/clients`)
            .set('access', Storage.getItem('access'))
            .query({ userId: data.userId })
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function createInvoice(data, userId) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset()/60

        Superagent
            .post(`${HOST_API}/facturama/invoices`)
            .set('access', Storage.getItem('access'))
            .query({timezone})
            .query({userId})
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function createInvoiceFree(data, userId) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset()/60

        Superagent
            .post(`${HOST_API}/facturama/invoices/free`)
            .set('access', Storage.getItem('access'))
            .query({timezone})
            .query({userId})
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function updateClient(data, userId) {
    return new Promise((resolve, reject) => {
        Superagent
            .put(`${HOST_API}/facturama/clients`)
            .set('access', Storage.getItem('access'))
            .query({userId})
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}
